import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import styleToObject from 'style-to-object';
export const parseRedesignHeadingRTF = (text, { textColorClass, ignoreRteStyles, ignoreRteClasses, linkClassOverride = 'text-secondary-yorkShireCyan underline', customClass = '' } = {}) => {
    const parserOptions = {};
    parserOptions.replace = domNode => {
        const element = domNode;
        let rteStyle = {};
        if (!ignoreRteStyles) {
            const styleStr = element.attributes?.find(a => a.name === 'style');
            rteStyle = styleToObject(styleStr?.value);
        }
        let rteClasses = '';
        if (!ignoreRteClasses) {
            rteClasses =
                element.attributes?.find(a => a.name === 'class')?.value || '';
        }
        textColorClass = textColorClass || '';
        // TODO: Add mobiles styles for each tag
        if (element.tagName === 'h1') {
            return (React.createElement("h2", { style: rteStyle, className: `my-0 ${rteClasses || 'text-headline-xxl-mob lg:text-headline-xxl'} ${textColorClass}  ${customClass}` }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'h2') {
            return (React.createElement("h2", { style: rteStyle, className: `my-0 ${rteClasses || 'text-headline-xl-mob lg:text-headline-xl'} ${textColorClass}  ${customClass}` }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'h3') {
            return (React.createElement("h3", { style: rteStyle, className: `my-0 ${rteClasses || 'text-headline-l-mob lg:text-headline-l'} ${textColorClass}  ${customClass}` }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'h4') {
            return (React.createElement("h4", { style: rteStyle, className: `my-0 ${rteClasses || 'text-headline-m-mob lg:text-headline-m'} ${textColorClass}  ${customClass}` }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'h5') {
            return (React.createElement("h5", { style: rteStyle, className: `my-0 ${rteClasses || 'text-headline-s-mob lg:text-headline-s'} ${textColorClass} ${customClass}` }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'h6') {
            return (React.createElement("h6", { style: rteStyle, className: `my-0 ${rteClasses || 'text-body-m'} ${textColorClass} ${customClass}` }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'p') {
            return (React.createElement("p", { style: rteStyle, className: `${rteClasses || 'text-body-m'} ${textColorClass} ${customClass}` }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'a') {
            return (React.createElement("a", { style: rteStyle, className: `${rteClasses} ${linkClassOverride ? linkClassOverride : textColorClass} ${customClass}`, href: element.attribs.href, target: element.attribs.target }, domToReact(element.children, parserOptions)));
        }
        if (element.tagName === 'script') {
            var script = document.createElement('script');
            script.src = element.attribs.src;
            script.onload = () => {
                console.log('script loaded');
            };
            document.body.appendChild(script);
            return React.createElement(React.Fragment, null);
        }
    };
    return parse(text, parserOptions);
};
